import React from 'react';

export const ToggleOffIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="48" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="48" height="24" rx="12" fill="#DCDCDC" />
      <circle cx="12" cy="12" r="9" fill="white" />
    </svg>
  );
};
